import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiService {
  // private apiUrl = 'http://localhost:3000';
  private apiUrl = 'https://beeasy-back.onrender.com';

  
  constructor() {}

  getApi() {
    return this.apiUrl;
  }
}